export const getMaremmaData = () => ({
  name: "Maremma",
  country: "Italie",
  region: "Toscane",
  description: "La Maremma est une région viticole moderne de la Toscane, produisant des vins rouges et blancs de qualité avec des cépages traditionnels et internationaux.",
  type: "subregion",
  mapAreas: [
    { region: "Maremma", x: 45, y: 42, color: "#4B164C", size: 5 }
  ],
  statistics: {
    totalArea: "3,500 ha",
    production: "150,000 hl",
    wineries: "80+ domaines",
    villages: "8 communes",
    exportPercentage: "60%"
  },
  characteristics: {
    climate: "Climat méditerranéen tempéré, influence maritime",
    soil: "Sols argilo-calcaires, sables marins",
    viticulture: "Viticulture moderne, rendements contrôlés"
  },
  wineStyles: {
    red: "Rouges fruités et équilibrés, assemblages traditionnels et modernes",
    white: "Blancs secs et aromatiques, principalement de Vermentino"
  },
  history: "La Maremma a développé sa viticulture moderne dans les années 1990, combinant tradition toscane et innovation.",
  foodPairing: "Cuisine toscane, fruits de mer, viandes blanches, fromages",
  grapeVarieties: [
    {
      name: "Sangiovese",
      percentage: "40%",
      description: "Cépage traditionnel toscan, produisant des vins élégants et structurés",
      characteristics: "Élégant, tanins fermes, notes de cerise et d'épices",
      wineStyles: "Sec, moyen-corps, tannique"
    },
    {
      name: "Cabernet Sauvignon",
      percentage: "25%",
      description: "Cépage international, apportant structure et complexité",
      characteristics: "Structuré, tanins fermes, notes de cassis",
      wineStyles: "Sec, plein-corps, tannique"
    },
    {
      name: "Merlot",
      percentage: "20%",
      description: "Cépage d'assemblage, apportant rondeur et fruité",
      characteristics: "Fruité, tanins doux, structure équilibrée",
      wineStyles: "Sec, moyen-corps, fruité"
    },
    {
      name: "Vermentino",
      percentage: "10%",
      description: "Cépage blanc principal, produisant des vins secs et aromatiques",
      characteristics: "Sec, aromatique, notes d'agrumes et de fleurs",
      wineStyles: "Sec, léger, aromatique"
    },
    {
      name: "Syrah",
      percentage: "5%",
      description: "Cépage d'assemblage, apportant puissance et épices",
      characteristics: "Puissant, épicé, notes de poivre noir",
      wineStyles: "Sec, plein-corps, épicé"
    }
  ]
}); 